import * as ActionTypes from './ActionTypes';
const createAction = method => location => ({
  type: ActionTypes.HISTORY_METHOD_CALLED,
  payload: {
    method,
    location
  }
});
export const push = createAction('push');
export const goBack = createAction('goBack');
export const replace = createAction('replace');